<template>
    <div>
    <v-tabs
        color="secondary"
        dark
    >
   <v-tabs-slider color="white"></v-tabs-slider>
    <v-tab @click="way='login'">
     <img :src="require('../assets/smartphone.svg')" :width="20"/>
       &nbsp; &nbsp;Login With OTP
    </v-tab>
    <v-tab @click="way='password'">
     <img :src="require('../assets/password.svg')" :width="20"/>
       &nbsp; &nbsp;Login With Password
    </v-tab>
    <v-tab @click="way='signup'">
        <img :src="require('../assets/password.svg')" :width="20"/>
        &nbsp; &nbsp;Need to  Signup?
    </v-tab>
    <v-tab @click="way='forgot'">
        <img :src="require('../assets/password.svg')" :width="20"/>
        &nbsp; &nbsp;Forgot Password
    </v-tab>
    </v-tabs>
    <Login  v-show="way==='login'"/>
    <Password v-show="way==='password'" />
    <Signup v-show="way==='signup'" />
    <Forgot v-show="way === 'forgot'"/>
  </div>


</template>
<script>
import Password from '../account/LoginWithPassword.vue'
import Login from '../account/Login.vue'
import Signup from '../account/Signup.vue'
import Forgot from "../account/Forgot";
export default {
    data(){
        return{
            way:'login',
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    watch:{
        user(value){
        let vm = this;
        if(vm.user.phone){
            this.$router.push("/settings");
        }
        }
    },
    mounted(){
        let vm = this;
        if(vm.user.phone){
            this.$router.push("/settings");
        }
    },
    components:{
        Login,
        Password,
        Signup,
        Forgot
    }
}
</script>
